import { ft } from '../lib/utils';

const LABELS = {
  pleaseEnter: ft('i18n_common_please_enter', '请输入 ')
};

export const i18nConfig = {
  data() {
    return {
      i18nObj: {}
    };
  },
  methods: {
    setI18n(item) {
      const i18nKey = item.i18nKey;
      const $t = this.$t.bind(this);

      const isI18n = typeof $t === 'function';

      // 多语言方法未初始化时, 不取多语言内容覆盖已有的 label
      if (isI18n && i18nKey) {
        const newLabel = $t(i18nKey);

        if (!newLabel.includes('i18n_')) {
          item.label = newLabel;
          // 多语言内容已根据别名设置, 此处不再需要未翻译的别名
          item.displayName = '';
        }

        item.pleaseInput = $t('i18n_common_please_enter');
      } else {
        // 设置别名
        this.setDisplayName(item);
        item.pleaseInput = LABELS.pleaseEnter;
      }
    },

    setDisplayName(item) {
      if (item.displayName && !item.displayName.includes('i18n_')) {
        item.label = item.displayName;
      }
      item.pleaseInput = LABELS.pleaseEnter;
    },

    $ts(str, defaultValue) {
      const $t = this.$t.bind(this);
      const word = $t(str);

      if (word && !word.startsWith('i18n')) {
        return word;
      } else {
        return defaultValue;
      }
    }
  },
  computed: {
    // pageCode: function () {
    //   const code = this.page + '_' + this.role + '_' + this.type;
    //   return code;
    // }
  }
};
